import {ModuleWithProviders, NgModule, Optional, SkipSelf} from '@angular/core';
import {CommonModule} from '@angular/common';
import {TorchAPIConfiguration, TorchAPIConfigurationParams} from '../../config/api.configuration';
import {LoggingService} from '../../../app/shared/services/logging.service';

@NgModule({
  imports: [
    CommonModule,
  ],
})
export class TorchDevopsEngineeringModule {
  constructor(@Optional() @SkipSelf() parentModule: TorchDevopsEngineeringModule, private logger: LoggingService) {
    if (parentModule) {
      throw new Error('TorchDevopsEngineeringModule is already loaded. Import in your base TorchBackend only.');
    }

    logger.log('Loaded TorchDevopsEngineeringModule');
  }

  static forRoot(params: TorchAPIConfigurationParams): ModuleWithProviders<unknown> {
    return {
      ngModule: TorchDevopsEngineeringModule,
      providers: [
        {
          provide: TorchAPIConfiguration,
          useValue: params
        },
      ]
    };
  }
}
